import { format } from 'date-fns'

const formatSavedSearch = (timestamp: number) =>
  `Saved search from ${format(timestamp, "MMM dd, yyyy 'at' hh:mm")}`

export default formatSavedSearch
